export default __webpack_public_path__ + "static/ehm-nutri-color-1d5ad6da4eeaa3c7a30c22ed3f4e1b10.webp";